<template>
    <auth-card class="invalid-wallboard-number">
        <p class="invalid-wallboard-number-title">{{ $t("login.invalid-wallboard-number-title") }}</p>

        <p class="invalid-wallboard-number-text">{{ $t("login.invalid-wallboard-number-text") }}</p>
    </auth-card>
</template>

<script>
import AuthCard from "./base/AuthCard.vue";

export default {
    name: "InvalidWallboardNumber",
    components: { AuthCard }
}
</script>

<style scoped>

</style>
